const dev = {
    IS_DEV: true,
    TITLE: "DEV: School Accounts BiK",
};

export default dev;

